import script from "./ColumnSort.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnSort.vue?vue&type=script&setup=true&lang=js"

import "./ColumnSort.vue?vue&type=style&index=0&id=5be91415&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be91415"]])

export default __exports__